<template lang="pug">
  #maintenance
    .maintenance-container
      .maintenance-content
        .logo-section
          WtSvgIcon(icon="be-well-logo" height="79px" width="79px")

        .text-section
          WtTitle(h1) System Maintenance
          p.subtitle We are currently undergoing scheduled maintenance.
          p.subtitle-small Thank you for your patience. We will be back online shortly.
          p.hiddentext OPENSHIFT INSTANCE

</template>

<script>
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "Maintenance",
  components: {
    WtSvgIcon,
    WtTitle
  },
  created() {
    // Remove navbar fixed positioning to prevent bleed
    document.querySelector("body").classList.remove("has-navbar-fixed-top");
  }
};
</script>

<style lang="scss" scoped>
#maintenance {
  min-height: 100vh;
  background-color: $white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  .maintenance-container {
    max-width: 600px;
    text-align: center;

    .maintenance-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
    }

    .logo-section {
      margin-top: 2rem;
    }

    .text-section {
      h1 {
        font-size: 2.5rem;
        color: $grey-dark;
        margin-bottom: 1rem;

        + mobile {
          font-size: 1.8rem;
        }
      }

      .subtitle {
        font-size: 1.1rem;
        color: $grey;
        margin: 0.5rem 0;
        line-height: 1.6;
      }

      .subtitle-small {
        font-size: 1rem;
        color: $grey-dark;
        margin: 0.5rem 0;
        line-height: 1.6;
      }

      .hiddentext {
        color: #ffffff;
      }
    }
  }
}
</style>
